export const moduleSlug = "USER_AGENTS";

export default { moduleSlug };